import lodash from 'lodash'
import * as services from '@/pages/person/manage/service'
import { upSuperAdmin } from './util'

const initialvalue = {
  page: {
    page_num: 1,
    page_size: 20,
    search_key: '',
  },
  status: 0, // 在职状态，0所有，1在职，2离职
  tag_id: '', // 选中的标签id,空字符串代表所有
}

const UserModel = {
  namespace: 'personList',

  state: {
    search: lodash.cloneDeep(initialvalue),
    personTotal: 0,
    personList: [],
    tagList: [],
    spinning: false,
    tagSpinning: false,
    selectedID: [],
    // status: 0, // 在职状态，0所有，1在职，2离职
    // tag_id: '', // 选中的标签id
  },

  subscriptions: {
    setup: ({ dispatch, history }) => {
      return history.listen(({ pathname }) => {
        if (pathname === '/system/person/manage') {
          dispatch({
            type: 'tagList',
            payload: {},
          })
          dispatch({
            type: 'personList',
            payload: lodash.cloneDeep(initialvalue),
          })
        }
      })
    },
  },
  effects: {
    // tag list
    *tagList({ payload }, { put, call, select }) {
      yield put({
        type: 'setState',
        payload: { tagSpinning: true },
      })
      const res = yield call(services.tagList, payload)
      yield put({
        type: 'setState',
        payload: {
          tagList: res?.data?.tags,
          tagSpinning: false,
        },
      })
      return res
    },

    // create tag
    *createTag({ payload }, { put, call, select }) {
      const res = yield call(services.createTag, payload)
      return res
    },

    // delete tag
    *deleteTag({ payload }, { put, call, select }) {
      const res = yield call(services.deleteTag, payload)
      return res
    },

    // update tag
    *updateTag({ payload }, { put, call, select }) {
      const res = yield call(services.updateTag, payload)
      return res
    },

    // 给用户打标
    *markTag({ payload }, { put, call, select }) {
      const res = yield call(services.markTag, payload)
      return res
    },

    // 人员 list
    *personList({ payload }, { put, call, select }) {
      yield put({
        type: 'setState',
        payload: { spinning: true },
      })
      const res = yield call(services.personList, payload)
      yield put({
        type: 'setState',
        payload: {
          personList: res?.data?.users,
          personTotal: res?.data?.page?.total || 0,
          search: payload,
          spinning: false,
        },
      })
      return res
    },

    // 添加人员
    *addUser({ payload }, { put, call, select }) {
      const res = yield call(services.addUser, payload)
      return res
    },

    // 删除人员
    *deleteUser({ payload }, { put, call, select }) {
      const res = yield call(services.deleteUser, payload)
      return res
    },

    // 编辑人员
    *editUser({ payload }, { put, call, select }) {
      const res = yield call(services.editUser, payload)
      return res
    },

    *importPerson({ payload }, { put, call, select }) {
      const res = yield call(services.importPerson, payload)
      return res
    },
    // 导入员工2.0
    *importPersonDownloadCenter({ payload }, { put, call, select }) {
      const res = yield call(services.importPersonDownloadCenter, payload)
      return res
    },
    // 导出员工
    *exportPersonDownloadCenter({ payload }, { put, call, select }) {
      const res = yield call(services.exportPersonDownloadCenter, payload)
      return res
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}

export default UserModel
